<template>
  <div>
    <NewProvider @created="handleSuccessProvider" />
    <NewClient @create="handleSuccessClient" />

    <b-modal
      :size="
        idCreate == 'finance_configuration_category' ||
        idCreate == 'finance_configuration_account'
          ? 'lg'
          : 'md'
      "
      no-close-on-backdrop
      hide-footer
      id="idCreate"
      :title="titleModalIdCreate"
    >
      <NewAccount
        v-if="idCreate == 'finance_configuration_account'"
        @success="handleSuccessAccount"
      />
      <NewCatgegory
        v-if="idCreate == 'finance_configuration_category'"
        @success="handleSuccessCategory"
      />
      <NewProfitCostCenter
        v-if="idCreate == 'finance_configuration_profit_cost_center'"
        @success="handleSuccessProfitCostCenter"
      />
      <ModalIdCreate
        v-if="
          idCreate != 'finance_configuration_account' &&
          idCreate != 'finance_configuration_category' &&
          idCreate != 'finance_configuration_profit_cost_center'
        "
        :id="idCreate"
        @success="handleSuccessIdCreate"
        @cancel="$bvModal.hide('idCreate')"
      />
    </b-modal>

    <div class="content-card row m-0">
      <div class="col-md-3 pt-0 pb-0 input-form-required">
        <label>Vence em</label>
        <input
          :disabled="data.boleto == 1"
          type="date"
          class="form-control form-control-sm"
          v-model="due_date"
        />
      </div>

      <div class="col-md-3 pt-0 pb-0 input-form-required">
        <label v-if="is_paid && data.type == 'CONTAS_A_PAGAR'">Paga em</label>
        <label v-if="is_paid && data.type == 'CONTAS_A_RECEBER'"
          >Recebida em</label
        >
        <input
          v-if="is_paid"
          type="date"
          class="form-control form-control-sm"
          v-model="paid_in_date"
        />
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="is_paid"
            id="is_paid"
          />
          <label
            v-if="data.type == 'CONTAS_A_PAGAR'"
            class="form-check-label"
            for="is_paid"
          >
            Foi paga?
          </label>
          <label
            v-if="data.type == 'CONTAS_A_RECEBER'"
            class="form-check-label"
            for="is_paid"
          >
            Recebida?
          </label>
        </div>
      </div>

      <div class="col-md-6 pt-0 pb-0 input-form-required">
        <LabelRequiredField label="Na conta" />
        <v-btn
          v-if="data.boleto == 0"
          x-small
          class="btn-add float-right"
          @click="handleIdModalCreate('finance_configuration_account')"
          ><i class="fas fa-plus mr-2"></i> NOVA</v-btn
        >
        <select
          class="form-control form-control-sm"
          :disabled="data.boleto == 1"
          v-model="finance_configuration_account_id"
        >
          <option
            v-for="account in finance_configuration_account"
            :key="account.id"
            :value="account.id"
          >
            {{ account.account_nickname }}
          </option>
        </select>
      </div>
    </div>

    <div
      class="content-card row m-0"
      v-if="repeat == 'MAIS_DE_UMA_VEZ' || repeat == 'SEMPRE'"
    >
      <div
        v-if="['NAO_SE_REPETE', 'MAIS_DE_UMA_VEZ', 'SEMPRE'].includes(repeat)"
        class="col-md-4"
      >
        <label class="mr-2">Repetir</label>
        <input
          v-if="repeat == 'NAO_SE_REPETE'"
          type="text"
          disabled
          value="NÃO SE REPETE"
          class="v-modern-input pl-2 pr-2"
        />
        <input
          v-if="repeat == 'MAIS_DE_UMA_VEZ'"
          type="text"
          disabled
          value="MAIS DE UMA VEZ"
          class="v-modern-input pl-2 pr-2"
        />
        <input
          v-if="repeat == 'SEMPRE'"
          type="text"
          disabled
          value="SEMPRE"
          class="v-modern-input pl-2 pr-2"
        />
      </div>

      <div
        v-if="repeat == 'MAIS_DE_UMA_VEZ' || repeat == 'SEMPRE'"
        class="col-md-4"
      >
        <label class="mr-2">Periodicidade</label>
        <select
          disabled
          class="v-modern-select pl-2 pr-2"
          v-model="periodicity"
        >
          <option value="">SELECONE...</option>
          <option value="SEMANAL">SEMANAL</option>
          <option value="QUINZENAL">QUINZENAL</option>
          <option value="MENSAL">MENSAL</option>
          <option value="BIMESTRAL">BIMESTRAL</option>
          <option value="TRIMESTRAL">TRIMESTRAL</option>
          <option value="SEMESTRAL">SEMESTRAL</option>
          <option value="ANUAL">ANUAL</option>
        </select>
      </div>

      <div v-if="repeat == 'MAIS_DE_UMA_VEZ'" class="col-md-4">
        <span class="mr-2">Por</span>
        <input
          disabled
          type="text"
          class="v-modern-input pl-2 pr-2"
          :value="`${how_many_times} vezes`"
        />
      </div>
    </div>

    <div class="content-card">
      <div class="row m-0" v-for="(item, key) in items" :key="key">
        <div
          class="col-md-11 pt-0 pb-0 c-warning text-right"
          v-if="item.resident_account"
        >
          LANÇAMENTO FATURADO
        </div>
        <div
          class="col-md-1 pt-0 pb-0 c-warning text-right"
          v-if="item.resident_account"
        ></div>
        <div class="col-md-11 pt-0 pb-0">
          <div class="row">
            <div class="col-md-6 input-form-required">
              <input
                :disabled="item.resident_account == 1"
                placeholder="Descrição"
                type="text"
                v-model="item.description"
                class="form-control form-control-sm"
              />
            </div>
            <div class="col-md-2 input-form-required">
              <select
                :disabled="item.resident_account == 1 || data.boleto == 1"
                v-model="item.spent_or_gain"
                class="form-control form-control-sm"
                @change="handleSpentOrGainItem(key)"
              >
                <option value="DEBITO">DÉBITO</option>
                <option value="CREDITO">CRÉDITO</option>
              </select>
            </div>
            <div class="col-md-4 input-form-required">
              <input
                :readonly="item.resident_account == 1 || data.boleto == 1"
                placeholder="Valor"
                type="text"
                @input="handleInputValue($event.target.value, key)"
                v-model="item.value"
                :class="[
                  'form-control form-control-sm',
                  item.spent_or_gain == 'DEBITO' && 'c-danger',
                  item.spent_or_gain == 'CREDITO' && 'c-success',
                ]"
              />
            </div>
            <div class="col-md-6 vue-treeselect-required text-right">
              <v-btn
                x-small
                class="btn-add"
                @click="handleIdModalCreate('finance_configuration_category')"
                ><i class="fas fa-plus mr-2"></i> NOVA</v-btn
              >
              <treeselect
                :options="finance_configuration_category"
                placeholder="SELECIONE..."
                v-model="item.finance_configuration_category_id"
                noChildrenText="NÃO POSSUI CATEGORIA(S) FILHA(S)"
              />
            </div>
            <div class="col-md-3 text-right">
              <v-btn
                x-small
                class="btn-add"
                @click="
                  handleIdModalCreate(
                    'finance_configuration_profit_cost_center'
                  )
                "
                ><i class="fas fa-plus mr-2"></i> NOVO</v-btn
              >
              <select
                v-model="item.finance_configuration_profit_cost_center_id"
                class="form-control form-control-sm"
              >
                <option :value="null">Centro de custo/lucro...</option>
                <option
                  v-for="profit_cost_center in finance_configuration_profit_cost_center"
                  :key="profit_cost_center.id"
                  :value="profit_cost_center.id"
                >
                  {{ profit_cost_center.description }}
                </option>
              </select>
            </div>
            <div
              class="col-md-3 text-right"
              v-if="item.spent_or_gain == 'DEBITO'"
            >
              <v-btn
                x-small
                class="btn-add"
                @click="handleIdModalCreate('provider')"
                ><i class="fas fa-plus mr-2"></i> NOVO</v-btn
              >
              <select
                :disabled="data.boleto == 1"
                v-model="item.provider_id"
                class="form-control form-control-sm"
              >
                <option :value="null">Fornecedor...</option>
                <option
                  v-for="provider in providers"
                  :key="provider.id"
                  :value="provider.id"
                >
                  {{ provider.company_name }}
                </option>
              </select>
            </div>
            <div
              class="col-md-3 text-right"
              v-if="item.spent_or_gain == 'CREDITO'"
            >
              <v-btn
                v-if="data.boleto == 0"
                :disabled="item.resident_account == 1"
                x-small
                class="btn-add"
                @click="handleIdModalCreate('finance_client')"
                ><i class="fas fa-plus mr-2"></i> NOVO</v-btn
              >
              <v-btn v-if="data.boleto == 1" disabled x-small class="btn-add"
                ><i class="fas fa-plus mr-2"></i> NOVO</v-btn
              >
              <select
                :disabled="item.resident_account == 1 || data.boleto == 1"
                v-model="item.finance_client_id"
                class="form-control form-control-sm"
              >
                <option :value="null">Cliente...</option>
                <option
                  v-for="client in finance_client"
                  :key="client.id"
                  :value="client.id"
                >
                  {{ client.name }}
                </option>
              </select>
            </div>
            <div class="col-md-3 text-right">
              <v-btn
                x-small
                class="btn-add"
                @click="
                  handleIdModalCreate('finance_configuration_payment_methods')
                "
                ><i class="fas fa-plus mr-2"></i> NOVA</v-btn
              >
              <select
                v-model="item.finance_configuration_payment_methods_id"
                class="form-control form-control-sm"
              >
                <option :value="null">Forma de pagamento...</option>
                <option
                  v-for="payment_method in finance_configuration_payment_methods"
                  :key="payment_method.id"
                  :value="payment_method.id"
                >
                  {{ payment_method.description }}
                </option>
              </select>
            </div>
            <div class="col-md-6 text-right">
              <vs-select
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0 pl-0 pr-0"
                placeholder="Tags..."
                multiple
                autocomplete
                v-model="item.finance_configuration_tag_ids"
              >
                <vs-select-item
                  v-for="tag in finance_configuration_tag"
                  :key="tag.id"
                  :text="tag.description"
                  :value="tag.id"
                />
              </vs-select>
              <v-btn
                x-small
                class="btn-add"
                @click="handleIdModalCreate('finance_configuration_tag')"
                ><i class="fas fa-plus mr-2"></i> NOVA TAG</v-btn
              >
            </div>
            <div class="col-md-3">
              <select
                v-model="item.cost_type"
                class="form-control form-control-sm"
              >
                <option :value="null">Tipo de custo...</option>
                <option
                  v-for="type in cost_types"
                  :key="type.value"
                  :value="type.value"
                >
                  {{ type.description }}
                </option>
              </select>
            </div>
            <div class="col-md-3">
              <select
                v-model="item.cost_appropriation"
                class="form-control form-control-sm"
              >
                <option :value="null">Apropriação de custo...</option>
                <option
                  v-for="appropriation in cost_appropriations"
                  :key="appropriation.value"
                  :value="appropriation.value"
                >
                  {{ appropriation.description }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div
          class="col-md-1 d-flex align-items-center justify-content-center pt-0 pb-0"
        >
          <ConfirmationDialog
            v-if="
              itemsWithId.length > 1 && item.id && item.resident_account == 0
            "
            small
            headerClass="modal-header-i"
            message-title="REMOVER?"
            :message-body="`Deseja realmente remover o item?`"
            open-class="btn-delete"
            open-left-icon="fa-times"
            @yes="handleDeleteItem(item.id)"
          />
          <ConfirmationDialog
            v-if="
              itemsWithId.length > 1 &&
              item.id &&
              item.resident_account == 1 &&
              !item.resident_has_accommodation_item_id
            "
            small
            headerClass="modal-header-i"
            message-title="REMOVER?"
            message-body="Deseja realmente excluir o faturamento? Ao confirmar, o faturamento vai ficar com status pendente."
            open-class="btn-delete"
            open-left-icon="fa-times"
            @yes="deleteInvoicedEntry(item.id)"
          />
          <ConfirmationDialog
            v-if="items.length > 1 && !item.id && item.resident_account == 0"
            small
            headerClass="modal-header-i"
            message-title="REMOVER?"
            :message-body="`Deseja realmente remover o item?`"
            open-class="btn-delete"
            open-left-icon="fa-times"
            @yes="handleRemoveItem(key)"
          />
        </div>
      </div>
    </div>

    <div class="content-card text-right p-3">
      <v-btn
        class="btn-modern btn-modern-info"
        v-if="data.boleto == 0"
        @click="handleAddItem"
        ><i class="fas fa-plus mr-2"></i> ADICIONAR OUTRO ITEM</v-btn
      >
    </div>

    <b-modal
      size="lg"
      no-close-on-backdrop
      hide-footer
      :id="`attachments_${data.id}`"
      title="ANEXOS"
    >
      <Attachments
        :finance_launch_bills_to_pay_installments_id="data.id"
        @success="handleSuccessAttachments(data.id)"
      />
    </b-modal>

    <div class="content-card">
      <div class="row m-0">
        <div class="col-md-6 pt-0 pb-0">
          <label>Observação</label>
          <ChromeSpeechToTextTextarea rows="3" v-model="note" />
        </div>
        <div class="col-md-6 pt-0 pb-0">
          <div class="row">
            <div class="col-md-12 pt-0 pb-0">
              <label>Competência</label>
              <input
                type="date"
                class="form-control form-control-sm"
                v-model="competence"
              />
            </div>
            <div class="col-md-12 pt-0 pb-0">
              <label>Tipo de documento</label>
              <select
                class="form-control form-control-sm"
                v-model="finance_configuration_document_types_id"
              >
                <option
                  v-for="document_type in finance_configuration_document_types"
                  :key="document_type.id"
                  :value="document_type.id"
                >
                  {{ document_type.description }}
                </option>
              </select>
            </div>
            <div class="col-md-12 pt-0 pb-0">
              <label>Número do documento</label>
              <input
                type="text"
                class="form-control form-control-sm"
                v-model="document_number"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-card">
      <WarningRequiredFields />
      <ErrorsMessages :errors="errors" />
    </div>

    <div class="content-card row m-0">
      <div class="col-md-2">
        <v-btn class="btn-modern btn-modern-delete mr-2" @click="handleCancel"
          ><i class="fas fa-times mr-2"></i>CANCELAR
        </v-btn>
      </div>

      <div class="col-md-10 text-right">
        <v-btn
          class="btn-modern btn-modern-info mr-1"
          @click="$bvModal.show(`attachments_${data.id}`)"
          ><i class="fas fa-copy mr-2"></i> ADICIONAR ARQUIVO</v-btn
        >
        <v-btn
          v-if="
            data.is_repeat == 'SEMPRE' || data.is_repeat == 'MAIS_DE_UMA_VEZ'
          "
          :disabled="loading"
          @click="updateAndNext"
          class="btn-modern btn-modern-save mr-2"
          ><i class="fas fa-check mr-2"></i
          >{{ loading ? "CARREGANDO" : "SALVAR ESTE E OS PRÓXIMOS" }}
        </v-btn>
        <v-btn
          :disabled="loading"
          @click="update"
          class="btn-modern btn-modern-save"
          ><i class="fas fa-check mr-2"></i
          >{{ loading ? "CARREGANDO" : "SALVAR" }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../../Components/ErrorsMessages";

import ConfirmationDialog from "../../../../Components/ConfirmationDialog";

import ChromeSpeechToTextTextarea from "../../../../Components/ChromeSpeechToTextTextarea";

import LabelRequiredField from "../../../../Components/LabelRequiredField";

import WarningRequiredFields from "../../../../Components/WarningRequiredFields";

import Treeselect from "@riophae/vue-treeselect";

import Attachments from "./Attachments";

import ModalIdCreate from "../../SpentGain/ModalIdCreate";

import NewAccount from "../../../Configuration/Accounts/Create";
import NewCatgegory from "../../../Configuration/Categories/Create";
import NewProfitCostCenter from "../../../Configuration/CostProfitCenter/Create";
import NewProvider from "../../../Provider/NewProvider";
import NewClient from "../../../Client/NewFinanceClient";

import {
  formatValueOnKeyUp,
  formatValueNegativeOnKeyUp,
} from "../../../../../lib/format";

import api from "../../../../../services/api";

import toast from "../../../../../lib/ToastNotification";

import moment from "moment";

export default {
  name: "Edit",

  components: {
    ErrorsMessages,
    ConfirmationDialog,
    ChromeSpeechToTextTextarea,
    LabelRequiredField,
    WarningRequiredFields,
    Treeselect,
    Attachments,
    ModalIdCreate,
    NewAccount,
    NewCatgegory,
    NewProfitCostCenter,
    NewProvider,
    NewClient,
  },

  props: {
    data: Object,
    providers: Array,
    finance_client: Array,
    finance_configuration_account: Array,
    finance_configuration_document_types: Array,
    finance_configuration_payment_methods: Array,
    finance_configuration_category: Array,
    finance_configuration_profit_cost_center: Array,
    finance_configuration_tag: Array,
    cost_types: Array,
    cost_appropriations: Array,
  },

  data() {
    return {
      idCreate: "",
      titleModalIdCreate: "",

      finance_configuration_account_id: "",
      due_date: "",
      finance_configuration_document_types_id: "",
      how_many_times: "",
      document_number: "",
      competence: "",
      note: "",
      paid_in_date: "",
      periodicity: "",
      repeat: "NAO_SE_REPETE",
      is_paid: false,

      items: [],
      itemsWithId: [],

      loading: false,

      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    formatValueOnKeyUp,
    formatValueNegativeOnKeyUp,

    postPendingBilling() {
      this.$emit("postPendingBilling");
    },

    handleSuccessAttachments(id) {
      this.$bvModal.hide(`attachments_${id}`);
      this.$emit("success");
    },

    handleInputValue(value, key) {
      if (this.items[key].spent_or_gain == "DEBITO") {
        this.items[key].value = formatValueNegativeOnKeyUp(value);
      } else {
        this.items[key].value = formatValueOnKeyUp(value);
      }
    },

    handleSpentOrGainItem(key) {
      this.items[key].provider_id = "";
      this.items[key].finance_client_id = "";
      this.handleInputValue(this.items[key].value, key);
    },

    handleAddItem() {
      let { items } = this;

      let lastItem = items[items.length - 1];

      let {
        finance_configuration_category_id,
        finance_configuration_profit_cost_center_id,
        provider_id,
        finance_client_id,
        finance_configuration_payment_methods_id,
        // finance_configuration_tag_ids,
        cost_type,
        cost_appropriation,
        spent_or_gain,
      } = lastItem;

      let item = {
        id: false,
        description: "",
        value: "",
        finance_configuration_category_id,
        finance_configuration_profit_cost_center_id,
        provider_id,
        finance_client_id,
        finance_configuration_payment_methods_id,
        finance_configuration_tag_ids: [],
        cost_type,
        cost_appropriation,
        spent_or_gain,
        resident_account: 0,
      };

      this.items = [...items, item];
    },

    handleRemoveItem(key) {
      this.items.splice(key, 1);
    },

    retrieve() {
      let { data } = this;

      this.finance_configuration_account_id =
        data.finance_configuration_account_id;
      this.due_date = data.due_date
        ? moment(data.due_date).format("YYYY-MM-DD")
        : "";
      this.finance_configuration_document_types_id =
        data.finance_configuration_document_types_id;
      this.how_many_times = data.how_many_times;
      this.document_number = data.document_number;
      this.paid_in_date = data.paid_in_date
        ? moment(data.paid_in_date).format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD");
      this.competence = data.competence
        ? moment(data.competence).format("YYYY-MM-DD")
        : "";
      this.periodicity = data.periodicity;
      this.note = data.note ? data.note : "";
      this.is_paid = data.is_paid == 1 ? true : false;

      this.repeat = data.is_repeat ? data.is_repeat : "";

      let itemsWithId = [];
      for (let item of data.items) {
        if (item.spent_or_gain == "DEBITO") {
          item.value = formatValueNegativeOnKeyUp(item.value);
        } else {
          item.value = formatValueOnKeyUp(item.value);
        }
        itemsWithId.push(item.id);
        this.items.push({
          id: item.id,
          description: item.description,
          value: item.value,
          finance_configuration_category_id:
            item.finance_configuration_category_id,
          finance_configuration_profit_cost_center_id:
            item.finance_configuration_profit_cost_center_id,
          provider_id: item.provider_id,
          finance_client_id: item.finance_client_id,
          finance_configuration_payment_methods_id:
            item.finance_configuration_payment_methods_id,
          finance_configuration_tag_ids: item.finance_configuration_tag_ids,
          cost_type: item.cost_type,
          cost_appropriation: item.cost_appropriation,
          spent_or_gain: item.spent_or_gain,
          resident_account: item.resident_account,
          resident_has_accommodation_item_id:
            item.resident_has_accommodation_item_id,
        });
      }
      this.itemsWithId = itemsWithId;
    },

    handleCancel() {
      this.$emit("cancel");
    },

    async updateAndNext() {
      try {
        this.loading = true;

        const {
          data,
          finance_configuration_account_id,
          repeat,
          is_paid,
          due_date,
          paid_in_date,
          periodicity,
          how_many_times,
          items,
          note,
          competence,
          finance_configuration_document_types_id,
          document_number,
        } = this;

        let params = {
          finance_launch_bills_to_pay_id: data.finance_launch_bills_to_pay_id,
          id: data.id,
          finance_configuration_account_id,
          repeat,
          is_paid,
          due_date,
          paid_in_date,
          periodicity,
          how_many_times,
          items,
          note,
          competence,
          finance_configuration_document_types_id,
          document_number,
        };

        const response = await api.put(
          "/rest-home/financial/launch/pay-and-next",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("success");
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async update() {
      try {
        this.loading = true;

        const {
          data,
          finance_configuration_account_id,
          repeat,
          is_paid,
          due_date,
          paid_in_date,
          periodicity,
          how_many_times,
          items,
          note,
          competence,
          finance_configuration_document_types_id,
          document_number,
        } = this;

        let params = {
          finance_launch_bills_to_pay_id: data.finance_launch_bills_to_pay_id,
          id: data.id,
          finance_configuration_account_id,
          repeat,
          is_paid,
          due_date,
          paid_in_date,
          periodicity,
          how_many_times,
          items,
          note,
          competence,
          finance_configuration_document_types_id,
          document_number,
        };

        const response = await api.put(
          "/rest-home/financial/launch/pay",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("success");
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async handleDeleteItem(id) {
      try {
        this.loading = true;

        let data = { id };

        const response = await api.delete(
          "/rest-home/financial/launch/pay/item",
          { data }
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("success");
          this.$emit("successDelete");
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async deleteInvoicedEntry(id) {
      try {
        this.loading = true;

        let data = { id };

        const response = await api.delete(
          "/rest-home/financial/launch/pay/invoiced-entry",
          { data }
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("success");
          this.$emit("successDelete");
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleIdModalCreate(id) {
      if (id) {
        let titleModalIdCreate =
          {
            finance_configuration_account: "NOVA CONTA",
            finance_configuration_category: "NOVA CATEGORIA",
            finance_configuration_profit_cost_center:
              "NOVO CENTRO DE CUSTO/LUCRO",
            provider: "NOVO FORNECEDOR",
            finance_client: "NOVO CLIENTE",
            finance_configuration_payment_methods: "NOVA FORMA DE PAGAMENTO",
            finance_configuration_tag: "NOVA TAG",
            finance_configuration_document_types: "NOVO TIPO DE DOCUMENTO",
          }[id] || "";

        this.titleModalIdCreate = titleModalIdCreate;
        this.idCreate = id;
        if (id == "provider") {
          this.$bvModal.show("new_provider");
        } else if (id == "finance_client") {
          this.$bvModal.show("new_finance_client");
        } else {
          this.$bvModal.show("idCreate");
        }
      }
    },

    async handleSuccessAccount() {
      this.$bvModal.hide("idCreate");
      this.$emit("idCreate", "finance_configuration_account");
    },

    async handleSuccessCategory() {
      this.$bvModal.hide("idCreate");
      this.$emit("idCreate", "finance_configuration_category");
    },

    async handleSuccessProfitCostCenter() {
      this.$bvModal.hide("idCreate");
      this.$emit("idCreate", "finance_configuration_profit_cost_center");
    },

    async handleSuccessProvider() {
      this.$bvModal.hide("new_provider");
      this.$emit("idCreate", "provider");
    },

    async handleSuccessClient() {
      this.$bvModal.hide("new_finance_client");
      this.$emit("idCreate", "finance_client");
    },

    async handleSuccessIdCreate({ type }) {
      this.$bvModal.hide("idCreate");

      this.$emit("idCreate", type);
    },
  },
};
</script>

<style scoped>
/* #SpentGain label {
  font-weight: bold;
} */
.content-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  padding: 6px;
  border-bottom: 2px solid #e5e7eb;
  margin-bottom: 5px;
}
</style>